import Component from 'routes/Group/List'
import { getUserFromCtx } from 'shared/api'

const defaultProps = {}
const propTypes = {}

export function getServerSideProps(context) {
  const user = getUserFromCtx(context)

  return {
    props: {
      user,
    },
  }
}

export const Page = props => <Component {...props} />

Page.defaultProps = defaultProps
Page.propTypes = propTypes

export default Page
